<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="mb-0 ml-2" style="font-size: 16px">Contacts</h4>
      <a
        href="#"
        v-if="hasCurrentUserPermissionAccess('patients', 'create')"
        style="font-size: 14px"
        @click.prevent="$emit('onEdit', 4)"
      >
        Edit
      </a>
    </div>
    <div
      v-for="contact in contacts"
      :key="contact.id"
      class="d-flex flex-column border-top p-2 mt-2"
      style="font-size: 14px;"
    >
      <div class="mb-2">
        <strong>{{ contact.name }}</strong>
      </div>
      <div v-if="contact.email" class="mb-2">
        <i class="fa fa-envelope mr-2" aria-hidden="true"></i>
        <span>{{ contact.email }}</span>
      </div>
      <div v-if="contact.phone" class="mb-2">
        <i class="fa fa-phone mr-2" aria-hidden="true"></i>
        <span>{{ contact.phone }}</span>
      </div>
      <div v-if="contact.address" class="mb-2">
        <i class="fa fa-home mr-2" aria-hidden="true"></i>
        <span>{{ contact.address }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "EocViewSummaryContacts",
  props: ["eoc"],
  computed: {
    ...mapGetters("layout", ["hasCurrentUserPermissionAccess"]),
    contacts() {
      if (this.eoc.patient.contacts) {
        return this.eoc.patient.contacts.map(c => {
          const addressItems = [
            ...(c.address ? [c.address] : []),
            ...(c.city ? [c.city] : []),
            ...(c.state ? [c.state.name] : []),
            ...(c.zipCode ? [c.zipCode] : [])
          ];

          return {
            name: `${c.name}${
              c.relationship ? " (" + c.relationship.name + ")" : ""
            }`,
            email: c.email,
            phone: c.phone,
            address: addressItems.join(", ")
          };
        });
      }

      return [];
    }
  }
};
</script>
